module.exports = __webpack_public_path__ + "img/workout-notebook_B095Q6467J.61ccd91c.jpg";